var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { QuestionnaireProgressAction } from "../../../../redux/actions/job_seeker_questionnaire";
import { Status } from "../../../../redux/constants/status";
/**
 * The Resume Questionnaire Page
 * The entry point to the jobseeker questionnaire. It fetches any pages the
 * user saved in an earlier session and sends them on to the first page they
 * have not yet completed, or to the start if nothing has been saved.
 * @returns
 */
function ResumeQuestionnaire() {
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var _a = useState(false), requested = _a[0], setRequested = _a[1];
    var _b = useSelector(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function (state) { return state.rootReducer.JobSeekerQuestionnaireReducer; }), progressStatus = _b.progressStatus, resumePath = _b.resumePath;
    useEffect(function () {
        dispatch(QuestionnaireProgressAction());
        setRequested(true);
    }, [dispatch]);
    useEffect(function () {
        if (!requested || progressStatus === Status.Loading)
            return;
        if (!progressStatus) {
            // The questionnaire state was reset while the request was in flight
            dispatch(QuestionnaireProgressAction());
        }
        else if (resumePath) {
            navigate(resumePath, { replace: true });
        }
    }, [requested, progressStatus, resumePath, dispatch, navigate]);
    return (_jsx("div", __assign({ className: "py-8 text-center text-gray-500" }, { children: "Loading questionnaire\u2026" })));
}
export default ResumeQuestionnaire;
